import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const BRAND = "#1410DF";
const ACCENT = "#CC11D2";

const Section = styled.section`
  background: #f9fafb;
  padding: 72px 20px;
  @media (max-width: 768px) { padding: 56px 20px; }
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Tag = styled.span`
  display: inline-block;
  background: ${BRAND}18;
  color: ${BRAND};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 20px;
  margin-bottom: 16px;
`;

const Heading = styled.h2`
  font-size: 32px;
  font-weight: 900;
  color: #111827;
  margin-bottom: 16px;
  line-height: 1.2;
  @media (max-width: 768px) { font-size: 24px; }
`;

const Lead = styled.p`
  font-size: 17px;
  color: #4b5563;
  line-height: 1.75;
  max-width: 620px;
  margin-bottom: 40px;
  @media (max-width: 768px) { font-size: 15px; }
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 48px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 24px;
  border: 1.5px solid #e5e7eb;
  transition: box-shadow 0.2s, border-color 0.2s;
  &:hover {
    box-shadow: 0 6px 24px rgba(0,0,0,0.08);
    border-color: ${BRAND}40;
  }
`;

const CardIcon = styled.div`
  font-size: 28px;
  margin-bottom: 12px;
`;

const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 6px;
`;

const CardText = styled.p`
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
`;

const CtaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const PrimaryBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, ${BRAND} 0%, ${ACCENT} 100%);
  color: white;
  font-weight: 700;
  font-size: 16px;
  padding: 14px 28px;
  border-radius: 50px;
  text-decoration: none;
  box-shadow: 0 4px 20px rgba(20,16,223,0.25);
  transition: transform 0.18s, box-shadow 0.18s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(20,16,223,0.4);
  }
`;

const SecondaryLink = styled(Link)`
  font-size: 15px;
  color: ${BRAND};
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  &:hover { text-decoration: underline; }
`;

const PorQueKusina = () => (
  <Section>
    <Container>
      <Tag>¿Por qué Kusina?</Tag>
      <Heading>
        Más que una app.<br />Un aliado para tu restaurante.
      </Heading>
      <Lead>
        Kusina nació para los restaurantes que sostienen la gastronomía peruana de verdad —
        huariques, fondas y menús del día. Sin comisiones abusivas, sin contratos, con alguien de tu lado.
      </Lead>

      <CardsGrid>
        <Card>
          <CardIcon>💸</CardIcon>
          <CardTitle>Comisión justa</CardTitle>
          <CardText>
            Cobramos entre el 18–20% — la mitad de lo que cobran otras plataformas. El que más gana eres tú.
          </CardText>
        </Card>
        <Card>
          <CardIcon>🛵</CardIcon>
          <CardTitle>Logística compartida</CardTitle>
          <CardText>
            Kusina Delivery agrupa varios restaurantes en una sola ruta para reducir el costo por entrega.
          </CardText>
        </Card>
        <Card>
          <CardIcon>🤝</CardIcon>
          <CardTitle>Tu Pooler a tu lado</CardTitle>
          <CardText>
            Un representante de Kusina configura tu carta, coordina entregas y te acompaña en todo momento.
          </CardText>
        </Card>
      </CardsGrid>

      <CtaRow>
        <PrimaryBtn to="/sobre-nosotros">
          Conoce toda nuestra historia →
        </PrimaryBtn>
        <SecondaryLink to="/sobre-nosotros">
          Ver cómo funciona
        </SecondaryLink>
      </CtaRow>
    </Container>
  </Section>
);

export default PorQueKusina;
